import { render, staticRenderFns } from "./create-thread-retrieve.vue?vue&type=template&id=324f0786&scoped=true"
import script from "./create-thread-retrieve.vue?vue&type=script&lang=js"
export * from "./create-thread-retrieve.vue?vue&type=script&lang=js"
import style0 from "./create-thread-retrieve.vue?vue&type=style&index=0&id=324f0786&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324f0786",
  null
  
)

export default component.exports